import { PropsWithChildren, createContext, useCallback, useContext } from 'react';
import { useLocalStorage } from 'react-use';

import { useViewerRoles } from '@treams/treams-hooks';

const ManagerModeContext = createContext({
	enabled: false,
	enable: () => {},
	disable: () => {},
});

export default function ManagerModeProvider(props: PropsWithChildren) {
	const [enabled, setEnabled] = useLocalStorage('managerModeEnabled', false);
	const enable = useCallback(() => setEnabled(true), []);
	const disable = useCallback(() => setEnabled(false), []);

	const { isWorkspaceSuperuser, isManager } = useViewerRoles();

	return (
		<ManagerModeContext.Provider
			value={{
				enabled: enabled! && (isWorkspaceSuperuser || isManager),
				enable,
				disable,
			}}
		>
			{props.children}
		</ManagerModeContext.Provider>
	);
}

export function useManagerMode() {
	return useContext(ManagerModeContext);
}
